<div class="info-popover">
  <span class="material-symbols-outlined trigger-icon" aria-hidden="true">info</span>
  <div class="popover">
    {{ popoverText() }}
  </div>
</div>
